import { ApiResult } from 'common/models';
import { FeaturesAndActions } from 'common/models/roles-and-access/roleAccess.model';
import { HttpClient } from 'common/services/http-client.service';
import userConfig from 'common/redux/user/user.config';
import { featuresAndActionsMockData } from 'common/mock-data';
/**
 * if in case we need mock data of features and actions to work withot backend
 * return mockData in below getFeatures method
 * please note that this is only for development purpose
 * also to add a feture or action in mock data please add it in src\common\mock-data\index.ts file
 * and also src\common\config\routes.config.ts file
 * please refer to the comments in src\common\config\routes.config.ts file for more details
 * do not forget to remove mock data before pushing the code
 */
export class FeaturesService extends HttpClient {
    public static async getFeatures(): Promise<ApiResult<FeaturesAndActions>> {
        const data = (await FeaturesService.invokeApi<FeaturesAndActions>(
            userConfig.getFeatures()
        )) as unknown as Promise<ApiResult<FeaturesAndActions>>;

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const mockData = { errors: [], value: featuresAndActionsMockData, hasErrors: false };
        // return mockData;
        return data;
    }
}
